import { render, staticRenderFns } from "./OxyClassBreakpointIcon.vue?vue&type=template&id=945207c8&"
import script from "./OxyClassBreakpointIcon.vue?vue&type=script&lang=ts&"
export * from "./OxyClassBreakpointIcon.vue?vue&type=script&lang=ts&"
import style0 from "./OxyClassBreakpointIcon.vue?vue&type=style&index=0&id=945207c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports